<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
          <CRow>
            <CCol sm="12">
              <CRow>
                <CCol sm="3">
                  <CInput label="Metode Pembayaran" 
                  invalid-feedback="Metode Pembayaran should be filled" 
                  :readonly="isReadonly" 
                  v-model="$v.paymentForm.name.$model" 
                  :is-valid="!$v.paymentForm.name.$invalid"/>
                </CCol>
                <CCol sm="3">
                  <CInput label="Nomor Akun" 
                  invalid-feedback="Nomor Akun should be filled" 
                  :readonly="isReadonly" 
                  required v-model="$v.paymentForm.account_number.$model" 
                  :is-valid="!$v.paymentForm.account_number.$invalid"/>
                </CCol>
                
              </CRow>
            </CCol>
          </CRow>
          <CRow>

               <CCol sm="3">
              <CSelect
                label="Group"
                invalid-feedback="Please select group"
                :options="groupOptions"
                required
                 :readonly="isReadonly"
                placeholder="Please Select one"
                :value.sync="$v.paymentForm.group.$model"
                :is-valid="!$v.paymentForm.group.$invalid"
              />
            </CCol>
           
                  <CCol sm="3">
                    <div class="status">
                      <label for="status">Status</label>
                      <model-select
                        class="form-control"
                        id="status"
                        :options="statusList"
                        v-model="$v.paymentForm.status.$model"
                        :isError="$v.paymentForm.status.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.paymentForm.status.$invalid"
                        class="invalid-feedback-custom"
                      >Status should be filled.</div>
                    </div>
                  </CCol>
                
              
            </CRow>

          <CRow>

            <CCol sm="3">
              <CInput
                label="Ordering"
                invalid-feedback="Ordering should be filled"
                required
                 :readonly="isReadonly"
                v-model="$v.paymentForm.ordering.$model"
                :is-valid="!$v.paymentForm.ordering.$invalid"
              />
            </CCol>

          </CRow>
          
          <CRow>
            <CCol sm="3">
                <CTextarea
                  required
                  :readonly="isReadonly"
                  rows="4"
                  label="Description"
                  invalid-feedback="Description should be filled"
                  v-model="$v.paymentForm.description.$model"
                  :is-valid="!$v.paymentForm.description.$invalid"
                />
              </CCol>
          </CRow>
        </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
            <CButton
              color="success"
              :disabled="$v.paymentForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Images</template>
            <UploadImage :paymentMethods="paymentForm" :payment-status="statusPayment"></UploadImage>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>

    <!-- <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Coverage</template>
            <br />
            <AgentCoverage :agent="paymentForm" :provinceList="provinceList" :agentCoverage="agentCoverageList" :agentStatus="paymentForm.status"></AgentCoverage>
          </CTab>
          <CTab>
            <template slot="title">Generate Password</template>
            <br />
            <GeneratePassword :agent="paymentForm" :agentPassword="agentPasswordList" :enableAdd="enableGeneratePassword" :agentStatus="paymentForm.status"></GeneratePassword>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard> -->
  </div>
</template>

<script>
import GlobalTable from "@/templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import UploadImage from "./tabs/UploadImagePayment";

export default {
  name: "PaymentMethodDetail",
  components: { GlobalTable, Loading, UploadImage},
  data() {
    return {
      title: "Payment Method Detail",
      paymentForm: tableInterfaces.payment_method,
      isLoading: false,
      activeTab: 0,
      statusList: [
        {value:"1", text : "Aktif"},
        {value:"2", text : "Non Aktif"}
      ],
      groupOptions:[
        { value: "1", label: "Virtual Account" },
        { value: "2", label: "E-Money" },
        { value: "3", label: "Store" },
        { value: "4", label: "Credit Card" },
        { value: "5", label: "Cash On Delivery" },
        { value: "6", label: "Pay Later" },
      ],
      channelOptions: [
        { value: "02", label: "Mandiri ClickPay" },
        { value: "03", label: "KlikBCA" },
        { value: "04", label: "DOKU Wallet" },
        { value: "06", label: "BRI e-Pay" },
        { value: "15", label: "Credit Card" },
        { value: "16", label: "Credit Card Tokenization" },
        { value: "17", label: "Recurring Payment" },
        { value: "18", label: "BCA KlikPay" },
        { value: "19", label: "CIMB Clicks" },
        { value: "22", label: "Sinarmas VA" },
        { value: "23", label: "MOTO" },
        { value: "25", label: "Muamalat Internet Banking" },
        { value: "26", label: "Danamon Internet Banking" },
        { value: "28", label: "Permata Internet Banking" },
        { value: "29", label: "BCA VA" },
        { value: "31", label: "Indomaret" },
        { value: "32", label: "CIMB VA" },
        { value: "33", label: "Danamon VA" },
        { value: "34", label: "BRI VA" },
        { value: "35", label: "Alfa VA" },
        { value: "36", label: "Permata VA" },
        { value: "37", label: "Kredivo" },
        { value: "38", label: "BNI VA" },
        { value: "39", label: "Linepay ECash" },
        { value: "41", label: "Mandiri VA" },
        { value: "42", label: "QNB VA" },
        { value: "43", label: "BTN VA" },
        { value: "44", label: "Maybank VA" },
        { value: "45", label: "BNI Yap!" },
        { value: "47", label: "Arta Jasa VA" },
      ],
      statusPayment: null,
      //enableAddPrice: true,
    };
  },
  validations: {
    paymentForm: {
      account_number: {required},
      name: { required },
      status: {required},
      payment_channel: {required},
      ordering: {required},
      group:{required},
      description: {required}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.paymentForm.status === "1" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.getAgentDetail(id);
    },
     back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent) {
        tableInterfaces.agent[i] = null;
      }
      this.paymentForm = tableInterfaces.agent;
    },
    getAgentDetail: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/payment_method/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.paymentForm = response.data.data;
            this.statusPayment = this.paymentForm.status;
            // alert(this.paymentForm);
            // this.paymentForm.agent_code = response.data.data.agent_code;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/payment_method/update", this.paymentForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Payment Method",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Payment Method");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[5]);
          });
      }
    },
    
    
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[5]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>